import { render } from "./SvgIcon.vue?vue&type=template&id=0e490385&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=0e490385&scoped=true&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.2.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e490385"]])

export default __exports__